// extracted by mini-css-extract-plugin
module.exports = {"card":"jut__Card__card","header":"jut__Card__header","headerText":"jut__Card__headerText"};